<template>
  <v-content style="height: 100%;">
    <v-container
      class="fill-height align-stretch"
      fluid
      v-on:keydown.enter="submitHandler"
    >
      <v-row
        class="d-flex align-stretch"
      >
        <v-col
          class="d-flex align-center justify-center"
          cols="6"
               sm="6"
               md="6"
        >
          <img alt="company logo" class="logo img-responsive" :src="logoPath">
        </v-col>
        <v-col
          class="d-flex align-center grey lighten-2 justify-center"
          cols="6"
          sm="6"
          md="6"
        >
          <v-col align="center"
                 justify="center">
            <v-card class="form-container">
              <v-progress-linear value="0" height="4" indeterminate :active="$store.state.auth.isLoggingIn"></v-progress-linear>
              <v-card-text>
                <v-form ref="setPasswordForm">
                  <v-text-field
                    label="Password"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="password"
                    :rules="passwordRules"
                    v-on:keydown.enter="submitHandler"
                  />
                  <v-text-field
                    label="Confirm Password"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="confirmPassword"
                    :rules="confirmPasswordRules"
                    v-on:keydown.enter="submitHandler"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions class="d-flex justify-center px-5 pb-3">
                <v-btn color="primary" type="submit" @click="submitHandler">Set Password</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
  import { mapActions } from 'vuex'
  import validationRules from '@/common/validationRules'
  export default {
    data: () => ({
      email: '',
      emailRules: validationRules.email,
      token: '',
      password: '',
      passwordRules: validationRules.password,
      confirmPassword: '',
      logoPath: require('@/assets/logo.png')
    }),
    computed: {
      confirmPasswordRules () {
        const rules = []
        if (this.password.length > 0) {
          const rule = val => this.password === val || 'Passwords should match'
          rules.push(rule)
        }
        return rules
      }
    },
    methods: {
      ...mapActions(['login', 'setPassword', 'clearUserData']),
      submitHandler: async function () {
        if (!this.$refs.setPasswordForm.validate()) {
          return
        }
        const formData = {
          password: this.password,
          passwordConfirmation: this.confirmPassword,
          token: this.token
        }
        this.setPassword(formData)
        /* try {
           await this.login(formData)
           this.$router.push('/')
         } catch (e) {
           console.log(e)
         } */
      }
    },
    mounted () {
      this.clearUserData()
      this.token = this.$router.currentRoute.query.token
    }
  }
</script>

<style scoped>
  .logo {
    width: 380px;
  }
  .form-container {
    max-width: 500px;
  }
  .fill-height {
    padding: 0;
  }
  .row {
    margin-left: 0;
  }
</style>
